import { styled } from "@pigment-css/react";
import { Skeleton } from "@acto/taskpane/field-sales-2/components/primitives/Skeleton";

const Wrap = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[16],
  padding: `0 ${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[24]}`,
}));

const Card = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[16],
  padding: theme.fieldSalesTwo.spacing[20],
  borderRadius: theme.fieldSalesTwo.radius[38],
  background: theme.fieldSalesTwo.colors.surface.glass,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
}));

export function PageLoadingSkeleton() {
  return (
    <Wrap aria-hidden="true">
      <Card>
        <Skeleton.Line width={48} height={14} />
        <Skeleton.Line width="70%" height={22} />
        <Skeleton.Box width="100%" height={64} radius={20} />
      </Card>
      <Card>
        <Skeleton.Line width="100%" height={44} />
        <Skeleton.Line width="100%" height={44} />
        <Skeleton.Line width="100%" height={44} />
      </Card>
    </Wrap>
  );
}
